import { render, staticRenderFns } from "./DashboardHeading.vue?vue&type=template&id=4e7bc689&scoped=true&"
import script from "./DashboardHeading.vue?vue&type=script&lang=js&"
export * from "./DashboardHeading.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeading.vue?vue&type=style&index=0&id=4e7bc689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7bc689",
  null
  
)

export default component.exports